import Link from 'next/link';
import React, {ReactNode} from 'react';

interface IRenderNextImageProps {
  href: string;
  child: ReactNode;
  setting?: any;
}

const RenderNextLink: React.FC<IRenderNextImageProps> = ({href, child, setting}) => {
  return (
    <Link href={href} {...setting}>
      <a
        style={{
          textDecoration: 'none',
          color: '#1E1E1E',
        }}
      >
        {child}
      </a>
    </Link>
  );
};

export default RenderNextLink;
